/*
 * @Author: sam.hongyang
 * @LastEditors: sam.hongyang
 * @Description: 用于基础构建 tooltip 内容区
 * @Date: 2019-05-06 10:29:00
 * @LastEditTime: 2019-06-25 11:08:43
 */
import Popper from 'popper.js'
import Vue from 'vue'
import TTooltip from './tooltip.vue'

const noop = () => {}

class Ctor {
  constructor (options = {}) {
    this.popperJS = null
    this.componentEl = null

    // NOTE: 设置默认参数
    this.options = {
      transitionName: options.transitionName || 'fade',
      placement: options.placement || 'top',
      disabled: options.disabled || false,
      visible: options.visible || false,
      always: options.always || false,
      content: options.content || '',
      ellipsis: options.ellipsis || false,
      prefixCls: options.prefixCls || 'tooltip',
      onPopperShow: noop,
      onPopperHide: noop,
      color: options.color || ''
    }

    // NOTE: 设置 tip 的dom
    let el = this.componentEl
    if (!this.container) {
      const popupContainer = document.createElement('div')
      popupContainer.style.position = 'absolute'
      popupContainer.style.top = '0'
      popupContainer.style.left = '0'
      popupContainer.style.width = '100%'
      this.container = popupContainer
      el = document.createElement('div')
      this.componentEl = el
      this.container.appendChild(el)
    }
    if (!this.popDom) {
      this.popDom = new Vue({
        el: el,
        components: {
          TTooltip
        },
        data() {
          return {
            transitionName: 'fade',
            placement: 'top',
            disabled: false,
            visible: false,
            always: false,
            content: '',
            ellipsis: false,
            prefixCls: 'tooltip',
            color: ''
          }
        },
        template: '<t-tooltip :transition-name="transitionName" :color="color" :placement="placement" :disabled="disabled" :visible="visible" :always="always" :content="content" :ellipsis="ellipsis" :prefix-cls="prefixCls"></t-tooltip>'
      })
    } else {
      this.popDom.$forceUpdate()
    }
    this.popDom.$mount('')
  }

  /**
   * 用于更新state
   * @param {*} el
   * @param {*} binding
   */
  updateState(binding) {
    let options = binding.value
    Object.keys(options).map(key => {
      this.options[key] = options[key]
    })
  }

  onHandleTooltip(el, visible) {
    if (this.options.disabled) return
    this.options.visible = visible
    Object.keys(this.options).map(key => {
      if (
        key !== 'onPopperShow' &&
        key !== 'onPopperHide' &&
        key !== 'ctor'
      ) {
        this.popDom.$set(this.popDom, key, this.options[key])
      }
    })
    this.popDom.$forceUpdate()
    this.popperJS ? this.popperJS.update() : this.createTooltip(this.options, el)
    if (!this.options.always) {
      if (this.options.visible) {
        this.options.onPopperShow && this.options.onPopperShow()
      } else {
        this.options.onPopperHide && this.options.onPopperHide()
      }
    }
  }

  createTooltip (options, el) {
    let tooltipOptions = {
      gpuAcceleration: false,
      boundariesElement: 'viewport',
      forceAbsolute: true
    }
    const popper = this.popDom && this.popDom.$mount().$el ? this.popDom.$mount().$el : ''
    const reference = el
    if (!popper || !reference) return
    if (this.popperJS && this.popperJS.hasOwnProperty('destroy')) {
      this.popperJS.destroy()
    }
    document.body.appendChild(popper)
    const isIE10 = navigator.appVersion.indexOf('MSIE 10') !== -1
    const boundariesElement = isIE10 === true ? 'body' : 'viewport'
    tooltipOptions.placement = options.placement || 'top'
    tooltipOptions.modifiers = {
      preventOverflow: {
        boundariesElement: boundariesElement
      },
      computeStyle: {
        gpuAcceleration: false
      }
    }
    this.popperJS = new Popper(reference, popper, tooltipOptions)
    this.popperJS.disableEventListeners()
  }

  destoryPopper () {
    const popper = this.popDom.$el
    if (this.popperJS && popper) {
      if (popper.parentNode) {
        popper.parentNode.removeChild(popper)
      } else {
        this.popperJS.popper.parentNode.removeChild(this.popperJS.popper)
      }
      this.popperJS.destroy()
      this.popperJS = null
    }
  }
}

export default Ctor



// WEBPACK FOOTER //
// ./src/module/tooltip/constructor.js